import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Select from "react-select";
import { getAppParams } from "../../api/api";

const ImageList = (props) => {
  const [characters, updateCharacters] = useState([]);
  const [newItem, setnewItem] = useState("");

  /*   const newContainer = (event)=>{
      event.preventDefault();
      const newer ={
        "value":"unnamedItem",
        "label":"unamedItem",
        "order":characters.length+1,
        "id":characters.length+1
      }
      updateCharacters([...characters, newer]);
      
    } */
  const onChangeItem = (value) => {
    const newer = {
      value: value.key,
      label: value.name,
      order: characters.length + 1,
      id: value.key,
    };
    setnewItem(newer);

    setnewItem("");
    updateCharacters([...characters, newer]);

    const newArray = [...characters, newer];
    props.onChange(newArray);
  };

  const filterOption = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    /* eslint-disable no-unused-vars */
    const getDetails = () => {
      const opt = props.listData.map((item) => ({
        value: props.elem === true ? item.itemRef : item.itemid,
        label: props.elem === true ? item.itemType : item.itemRef,
        order: item.itemOrder,
        id: item.itemid,
      }));

      updateCharacters(opt);
    };

    getDetails();
    /* eslint-disable no-unused-vars */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listData]);
  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;
    props.onChange(newArr);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  return (
    <div className="row mb-2 mt-2">
      {props.dir === "rtl" && <div className="col-sm-6"></div>}
      <div className="col-sm-6">
        <div className="form-group">
          <div className="row">
            {props.dir === "rtl" && (
              <div className="col-md-4">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={() => props.show()}
                >
                  New
                </button>
              </div>
            )}
            <div className="col-md-8" dir={props.dir}>
              <Select
                name="multipleImage"
                className="form-control inside-select"
                filterOption={filterOption}
                options={props.allImage}
                value={newItem}
                onChange={onChangeItem}
              ></Select>
            </div>
            {!(props.dir === "rtl") && (
              <div className="col-md-4">
                <button
                  type="button"
                  className="btn btn-light btn-block"
                  style={{ width: "100px", marginTop: "8px", height: "40px" }}
                  onClick={() => props.show()}
                >
                  New
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId={"characters"}>
            {(provided) => (
              <ul
                className="products-list product-list-in-card pl-2 pr-2"
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ maxHeight: "350px", overflowY: "scroll" }}
              >
                {characters.map((item, index) => (
                  <Draggable
                    key={item.value}
                    draggableId={"item" + item.value}
                    index={index}
                  >
                    {(provided) => (
                      <li
                        className="item"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="product-info">
                          <a href="#!" className="product-title">
                            <div>
                              <img
                                src={getAppParams() + item.value}
                                alt={item.label}
                                style={{ height: props.height || "40px" }}
                              />{" "}
                              {item.label}
                            </div>
                          </a>
                          <div
                            className="text-right"
                            style={{ display: "inline", float: "right" }}
                          >
                            <a
                              className="btn btn-light btn-sm"
                              href="#!"
                              onClick={(event) => handleRemove(event, index)}
                            >
                              <i className="fas fa-trash"></i>
                            </a>
                          </div>
                        </div>
                      </li>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

export default ImageList;
